import { SR_API_ACTION_UTILITY_USER_SMS_CODE_LOGIN } from 'api/utilityActionTypes';

import { ANALYTICS_EVENT_UTILITY_USER_LOGIN } from 'client/analytics/eventList';

import { hasRolePartner } from 'common/utility/userRoles';

import { onLogicSuccess as onPartnerLoginSuccess } from 'client/actions/UtilityAuth/partnerSignup';

import { onLogicSuccess as onUserLogicSuccess } from 'client/actions/UtilityAuth/userSignup';

import analytics from 'client/analytics';

export default async function loginSmsCode({ state, utilityApiClient }, params) {
  await utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_USER_SMS_CODE_LOGIN,
    state: state,
    payload: {
      phone: params.phone,
      code: params.code,
      utilityActivationId: params.utilityActivationId,
      leaseStartDate: params.leaseStartDate,
    },
    async onSuccess({ user }) {
      state.set('utilityUser', user);
      state.commit();

      if (hasRolePartner(user.roles)) {
        await onPartnerLoginSuccess({
          state,
          utilityApiClient,
          user,
        });
      } else {
        await onUserLogicSuccess({
          state,
          utilityApiClient,
          user,
        });
      }

      analytics.track(ANALYTICS_EVENT_UTILITY_USER_LOGIN);
      params.onSuccess(user);
    },
    onError: params.onError,
  });
}
